'use client';

import styles from '@/app/ui/components/brands/searchbrands/searchstyle.module.scss';
import React, { useState } from 'react';
import { IBrand } from '@mybestbrands/types';
import { SearchBrandResult } from '@/app/ui/components/brands/searchbrands/SearchBrandResult';
import Image from 'next/image';
import useSearchSubmitHandler from '@/app/helpers/hooks/useSearchSubmitHandler';

export function SearchBrandForm(props: { placeholder: string; brands: IBrand[] }) {
  const searchFormRef = React.createRef<HTMLFormElement>();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState<IBrand[]>([]);
  const brands = props.brands;
  const handleSubmit = useSearchSubmitHandler(searchTerm);

  const onChangeHandler = (brandValue: string) => {
    setSearchTerm(brandValue);
    const searchingBrand = brandValue;
    const newResults = brands.flat().filter((_) => _.brandName.toLowerCase().startsWith(searchingBrand.toLowerCase()));
    return searchingBrand.length ? setResults(newResults) : setResults([]);
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <form
          ref={searchFormRef}
          onSubmit={handleSubmit}
          autoFocus={true}
          autoComplete="off"
          className={styles.searchBrands}>
          <Image
            className={`${styles.searchIcon}`}
            height={24}
            width={24}
            src="/intstatic/icons/search-black.svg"
            alt="Search icon"
          />
          <input
            type="search"
            id={'searchTerm'}
            name={'searchTerm'}
            enterKeyHint="search"
            autoFocus={false}
            placeholder={props.placeholder}
            value={searchTerm}
            className={`form-control rounded-0 border-0 border-top-0 border-start-0 border-end-0 px-2 w-100`}
            onChange={(e) => {
              onChangeHandler(e.target.value);
            }}
          />
        </form>
      </div>
      {results.length > 0 && <SearchBrandResult results={results} />}
    </>
  );
}
